
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solar-decommissioning",
      function () {
        return require("private-next-pages/solar-decommissioning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solar-decommissioning"])
      });
    }
  